import { Briefcase, ShoppingBag, Layers, Leaf, TrendingUp } from "lucide-react";

export const COMPANY = {
  name: "CLACH Global Services Limited",
  shortName: "Clach",
  tagline: "...igniting the world",
  logo: "/assets/clach-logo.png",
  mark: "/assets/clach-mark.png",
};

export const CONTACT = {
  country: "Nigeria",
  offices: [
    {
      city: "Lagos",
      address: "14b Olushola Agbaje Street, Lekki Phase 1, Lagos.",
    },
    {
      city: "Abuja",
      address: "No 6 Otukpo Street, Area 11, Garki, Abuja.",
    },
  ],
  phones: ["+234 708 040 9735"],
  email: "clachglob@gmail.com",
  website: "www.clachglobal.com",
  websiteUrl: "https://www.clachglobal.com",
};

export const NAV_ITEMS = [
  { path: "/", label: "Overview" },
  { path: "/about", label: "Company" },
  { path: "/services", label: "Services" },
  { path: "/sustainability", label: "Sustainability" },
  { path: "/capabilities", label: "Capabilities" },
  { path: "/contact", label: "Contact" },
];

export const INDUSTRIES = ["Energy", "Oil & Gas", "Environment", "Maritime"];

export const SERVICES = [
  {
    slug: "consulting",
    title: "Consulting",
    icon: Briefcase,
    image: "/assets/page_8_img_2.jpeg",
    summary:
      "Wide-ranging advisory for businesses and governmental clients navigating African operating environments.",
    highlights: ["Domestic market mastery", "Regulatory intelligence", "Continental expansion strategy"],
    body: [
      "Clach Global Services Limited offers wide-ranging consulting services to businesses and governmental clients. Armed with extensive understanding of the domestic market, full knowledge of the workings of governmental and regulatory systems and the interconnectivity of the extended global business environment, we help organizations and individuals create the value they are looking for.",
      "Our in-depth knowledge and understanding of African operating environments enables us to put ourselves in our clients' shoes to offer tailored solutions that best fit their needs. Clach is strategically positioned to help customers blend with the Nigerian business environment, taking full advantage of its massive opportunities while sustaining focus on global best practices and continental expansion opportunities.",
    ],
  },
  {
    slug: "procurement",
    title: "Procurement",
    icon: ShoppingBag,
    image: "/assets/page_9_img_2.jpeg",
    summary:
      "Equipment, materials, and refined petroleum product sourcing across upstream and downstream markets.",
    highlights: ["AGO, DPK, fuel oil & base oil", "Global mill relationships", "On-time, in-budget delivery"],
    body: [
      "We provide equipment and material procurement and supply services to the oil and gas industry throughout Nigeria and the rest of the world. Procurement has become an essential service in today's competitive marketplace, and our role is to find and supply the manufactured goods associated with the exploration and delivery of oil and gas.",
      "With decades of experience, Clach has relationships with renowned manufacturers, major mills and suppliers in the UK, across Europe, the USA, the Far East and the Sub-Continent. We supply equipment to the correct specifications, on time and within budget.",
    ],
  },
  {
    slug: "contracting-representation",
    title: "Contracting & Representation",
    icon: Layers,
    image: "/assets/page_10_img_2.jpeg",
    summary:
      "Integrated project delivery for exploration, production, gas processing, refining, and petrochemicals.",
    highlights: ["Vertically integrated operations", "Fast regional response", "Global delivery capabilities"],
    body: [
      "Clach Contracting and Representation delivers projects to oil and gas exploration and production, natural gas processing, refining, petrochemicals and industrial customers. Clach's regional structure combines local knowledge and fast response to customers' needs with global project delivery capabilities.",
      "Drawing on tools and resources honed through decades of operational and technical excellence, Clach executes projects safely, efficiently and consistently. The company's business is built on vertically integrated operations that improve efficiency and timeliness of project execution.",
    ],
  },
  {
    slug: "environmental-services",
    title: "Environmental Services",
    icon: Leaf,
    image: "/assets/page_11_img_2.jpeg",
    summary:
      "Environmental protection and operational footprint mitigation in partnership with government and stakeholders.",
    highlights: ["Footprint mitigation", "Stakeholder partnership", "Impact balancing"],
    body: [
      "Clach is passionate about environmental issues and has made environmental protection and preservation a base rock on which it operates. Environmental considerations have become central to the thinking of the oil industry and regulators in recent decades.",
      "Clach takes its responsibility towards the environment seriously and works with government and stakeholders to minimize the environmental footprint of operations. The challenge is to balance industrial impact with the benefits society takes from a secure energy supply.",
    ],
  },
  {
    slug: "trading-supply",
    title: "Trading & Supply",
    icon: TrendingUp,
    image: "/assets/page_12_img_2.jpeg",
    summary:
      "Global, multi-commodity, insurance-backed trading with import, warehousing, bulk trade, and distribution.",
    highlights: ["Insurance-backed trading", "Bulk purchase & warehousing", "Competitive pricing structures"],
    body: [
      "Trading is at the heart of Clach's business. Our teams are highly experienced, with expertise in sourcing and supplying the upstream and downstream sectors of the oil and gas industry, combined with solid logistics that ensure prompt delivery at competitive cost and value for money.",
      "In a marketplace where commodities grow ever more interrelated, Clach's trading is global, multi-commodity and insurance backed. We import, warehouse, bulk trade and distribute, creating value for customers throughout the supply chain.",
    ],
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Ethical Sensitivity",
    text: "Uncompromising standards across every transaction, prioritizing transparency and long-term trust.",
  },
  {
    number: "02",
    title: "Global Value Web",
    text: "International technical capability connected to deep African market execution.",
  },
  {
    number: "03",
    title: "Environmental Bedrock",
    text: "Preservation of local ecosystems is central to the operating doctrine.",
  },
  {
    number: "04",
    title: "Fatality-Free Safety",
    text: "Zero-incident workplaces are non-negotiable for staff, vendors, and partners.",
  },
];

export const CORE_VALUES = [
  "Ethical Sensitivity",
  "Professionalism",
  "Responsiveness",
  "Partnership",
  "Environmental Consciousness",
  "Corporate Social Responsibility",
];

export const PEOPLE = [
  {
    slug: "nwachukwu-okorie",
    name: "Nwachukwu Okorie",
    role: "Managing Director",
    photo: null,
    experience: "Provides executive leadership for Clach's strategy, partnerships, and integrated delivery across oil and gas, maritime, procurement, and environmental services.",
    focusAreas: ["Corporate strategy", "Client partnerships", "Integrated project delivery", "Business growth"],
  },
  {
    slug: "ngozi-nwachukwu",
    name: "Ngozi Nwachukwu",
    role: "Director, Finance & Risk Management",
    photo: null,
    experience: "Leads financial governance, commercial controls, and risk management discipline across Clach's trading, procurement, and contracting activities.",
    focusAreas: ["Financial governance", "Risk management", "Commercial controls", "Capital stewardship"],
  },
  {
    slug: "nnennaya-victor-ugwu",
    name: "Nnennaya Victor-Ugwu",
    role: "Director, HR/Administration",
    photo: null,
    experience: "Directs people operations, administration, and organizational systems that support responsive delivery and accountable workplace practices.",
    focusAreas: ["People operations", "Administration", "Workplace policy", "Organizational performance"],
  },
  {
    slug: "ibezue-egwudo",
    name: "Ibezue Egwudo",
    role: "Director, HSE & Projects",
    photo: null,
    experience: "Oversees health, safety, environment, and project execution standards with a focus on fatality prevention, compliance, and dependable delivery.",
    focusAreas: ["HSE leadership", "Project controls", "Safety compliance", "Operational excellence"],
  },
  {
    slug: "ikechukwu-agha",
    name: "Ikechukwu Agha",
    role: "Director, Operations & Logistics",
    photo: null,
    experience: "Leads operational coordination, logistics planning, and supply-chain execution for upstream and downstream energy customers.",
    focusAreas: ["Operations", "Logistics", "Supply chain", "Delivery coordination"],
  },
  {
    slug: "ezinne-ukpa",
    name: "Barr. Ezinne Ukpa",
    role: "Legal Counsel",
    photo: null,
    experience: "Advises on contracts, regulatory obligations, governance, and legal risk across Clach's commercial and project relationships.",
    focusAreas: ["Contracts", "Regulatory compliance", "Governance", "Legal risk"],
  },
];

export const SUSTAINABILITY_PILLARS = [
  {
    key: "Health & Safety",
    text: "All work processes target fatality prevention and the safety of our people, vendors, and contractors. Everyone takes personal responsibility for preventing injuries and occupational disease.",
  },
  {
    key: "Environment",
    text: "Clach works to reduce air emissions, biodiversity loss, water scarcity, waste, energy inefficiency, climate impact, and supply-chain risk.",
  },
  {
    key: "Communities",
    text: "Socio-economic contributions focus on education, capacity building, employment, and local procurement that creates opportunity and wealth.",
  },
  {
    key: "Human Rights",
    text: "Policies are guided by the UN Universal Declaration of Human Rights, with attention to security, equality, religious freedom, and protection from exploitation.",
  },
  {
    key: "Corporate Social Responsibility",
    text: "CSR initiatives generate economic benefits for host communities, with particular passion for orphans, widows, and environment-related causes.",
  },
];

export const CAPABILITY_IMAGES = [
  { src: "/assets/page_16_img_2.jpeg", label: "Offshore Energy" },
  { src: "/assets/page_16_img_4.jpeg", label: "Power Infrastructure" },
  { src: "/assets/page_16_img_6.jpeg", label: "Renewables" },
  { src: "/assets/page_16_img_8.jpeg", label: "Governance" },
];

export const LOGISTICS_IMAGES = [
  "/assets/page_7_img_1.jpeg",
  "/assets/page_7_img_2.jpeg",
  "/assets/page_7_img_3.jpeg",
  "/assets/page_7_img_4.jpeg",
  "/assets/page_7_img_5.jpeg",
  "/assets/page_7_img_6.jpeg",
  "/assets/page_7_img_7.jpeg",
  "/assets/page_7_img_8.jpeg",
];
